var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "vacancies" }, [
    _c(
      "div",
      { staticClass: "row" },
      [
        _c(
          "div",
          {
            staticClass: "vacancies__filters-container col-default-12",
            class: {
              "vacancies__filters-container--open": _vm.isFiltersChanged,
            },
          },
          [
            _c(
              "div",
              { staticClass: "vacancies__filters" },
              [
                _c(
                  "div",
                  {
                    staticClass:
                      "vacancies__search-input vacancies__filters-item col-default-12",
                  },
                  [
                    _c("z-input", {
                      staticClass: "vacancies__filters-item",
                      attrs: {
                        value: _vm.params.name,
                        placeholder: _vm.text.filters.title,
                        name: "name",
                      },
                      on: { input: _vm.selectName },
                    }),
                    _vm._v(" "),
                    _c("z-icon", {
                      attrs: {
                        name: "magnifying_glass",
                        dir: "top",
                        width: "24",
                        height: "24",
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c("z-select", {
                  staticClass:
                    "vacancies__filters-item col-default-4 col-tablet-12",
                  attrs: {
                    data: _vm.cityFilter,
                    value: _vm.params.city,
                    placeholder: _vm.text.filters.city,
                    disabled: !!_vm.params.name,
                  },
                  on: { change: _vm.selectCity },
                }),
                _vm._v(" "),
                _c("z-select", {
                  staticClass:
                    "vacancies__filters-item col-default-4 col-tablet-12",
                  attrs: {
                    data: _vm.specializationFilter,
                    value: _vm.params.specialization,
                    placeholder: _vm.text.filters.specialization,
                    disabled: !!_vm.params.name,
                  },
                  on: { change: _vm.selectSpecialization },
                }),
                _vm._v(" "),
                _c("z-select", {
                  staticClass:
                    "vacancies__filters-item col-default-4 col-tablet-12",
                  attrs: {
                    data: _vm.jobTypeFilter,
                    value: _vm.params.type,
                    placeholder: _vm.text.filters.jobType,
                    disabled: !!_vm.params.name,
                  },
                  on: { change: _vm.selectJobType },
                }),
              ],
              1
            ),
            _vm._v(" "),
            _vm.isFiltersChanged
              ? _c(
                  "button",
                  {
                    staticClass: "vacancies__filters-clear",
                    on: { click: _vm.clearFilters },
                  },
                  [
                    _vm._v(
                      "\n                " +
                        _vm._s(_vm.text.filters.reset) +
                        "\n            "
                    ),
                  ]
                )
              : _vm._e(),
          ]
        ),
        _vm._v(" "),
        _vm.isFiltersChanged
          ? _c(
              "z-caption",
              {
                staticClass: "vacancies__count col-default-12",
                attrs: { tag: "p", size: "xs" },
              },
              [_vm._v(_vm._s(_vm.text.count) + " " + _vm._s(_vm.nav.count))]
            )
          : _vm._e(),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "vacancies__preloader-wrapper" },
          [_vm.loading ? _c("z-preloader") : _vm._e()],
          1
        ),
        _vm._v(" "),
        _vm.vacancies.length
          ? _c(
              "div",
              { staticClass: "col-default-12" },
              [
                _vm._l(_vm.vacancies, function (vacancyCard, index) {
                  return _c("vacancies-card", {
                    key: index,
                    attrs: { vacancyInfo: vacancyCard },
                  })
                }),
                _vm._v(" "),
                _c("z-pagination", {
                  staticClass: "vacancies__pagination",
                  attrs: {
                    "show-next": "",
                    "show-prev": "",
                    data: {
                      currentPage: _vm.nav.current,
                      totalItems: _vm.nav.count,
                      totalPages: _vm.nav.total,
                      pageRange: 1,
                    },
                  },
                  on: { change: _vm.loadAnotherPage },
                }),
              ],
              2
            )
          : _c(
              "z-not-found",
              [
                [
                  _c(
                    "z-caption",
                    {
                      staticClass:
                        "vacancies__title vacancies__title--not-found",
                      attrs: { tag: "h2" },
                    },
                    [
                      _vm._v(
                        "\n                    " +
                          _vm._s(_vm.text.notFound.title) +
                          "\n                "
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "z-caption",
                    { staticClass: "vacancies__text", attrs: { tag: "p" } },
                    [
                      _vm._v(
                        "\n                    " +
                          _vm._s(_vm.text.notFound.text) +
                          "\n                "
                      ),
                    ]
                  ),
                ],
              ],
              2
            ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }